// The "alert" sort mode: what the owner was told about, then what the system almost
// told them about. Client-side only — the pane always holds the whole selected window,
// and the API keeps its two contract sorts (ADR 0005).

import type { MotionPeriodResponse } from "../../lib/api";

// Tiers (operator decision 2026-08-11): conveyed alerts first (this is where
// watch-instruction notifications land), then alerts still awaiting a verdict,
// then suppressed alerts, then everything else.
export const alertTier = (p: Pick<MotionPeriodResponse, "alert" | "decision">): number => {
  if (!p.alert) return 3;
  if (p.decision === "convey") return 0;
  if (p.decision === "suppress") return 2;
  return 1;
};

// Within a tier: unread first (mirrors the severity sort's convention — uses `unread`
// as fetched so opening a row never reorders the list), then recency.
export const compareByAlert = (a: MotionPeriodResponse, b: MotionPeriodResponse): number => {
  const unread = (p: MotionPeriodResponse): number => (p.unread ? 1 : 0);
  return (
    alertTier(a) - alertTier(b) ||
    unread(b) - unread(a) ||
    new Date(b.period_start_ts).getTime() - new Date(a.period_start_ts).getTime()
  );
};
